<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <form class="forms-sample" ref="anyName" @submit.stop.prevent="onSubmit" autocomplete="off">
            <div class="row mt-5">
                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                    <div class="row flex-grow">
                        <div class="col-12 grid-margin">

                            <h4 class="">Add Video</h4>
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <b-form-group label="Video Link" label-for="Videolink">
                                                <b-form-input type="url" id="Videolink" name="Videolink"
                                                    autocomplete="Videolink" placeholder="Video Link"
                                                    v-model="$v.form.Videolink.$model"
                                                    :state="$v.form.Videolink.$dirty ? !$v.form.Videolink.$error : null"
                                                    aria-describedby="input-1-live-feedback">
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-7">
                                            <b-form-group label="Video Order" label-for="VideoOrder">
                                                <b-form-input type="number" id="VideoOrder" name="VideoOrder"
                                                    autocomplete="VideoOrder" placeholder="Video Order"
                                                    v-model="$v.form.VideoOrder.$model"
                                                    :state="$v.form.VideoOrder.$dirty ? !$v.form.VideoOrder.$error : null"
                                                    aria-describedby="input-1-live-feedback">
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-7">
                                            <b-form-group label="Active" label-for="Active">
                                                <b-form-select v-model="form.Active" :options="ActiveOptions" class="mb-3"
                                                    value-field="item" text-field="name" disabled-field="notEnabled">
                                                </b-form-select>
                                            </b-form-group>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6"></div>
                                        <div class="col-md-6 mt-3">
                                            <b-button type="submit" variant="success" :disabled="isDisabled"
                                                class="btn float-right btn-success">
                                                <span>Submit</span>
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required, minLength, email, requiredIf, sameAs, integer } from "vuelidate/lib/validators";

export default {
    name: 'Users',
    mixins: [validationMixin],
    data() {
        return {
            ActiveOptions: [
                { item: 0, name: 'Inactive' },
                { item: 1, name: 'Active' },
            ],
            form: {
                id: '',
                Videolink: '',
                VideoOrder: '',
                Active: 0,
            },
            isDisabled: false,
        };
    },
    validations: {
        form: {
            Videolink: {
                required,
            },
            VideoOrder: {
                required,
            },
            Active: {
                required,
            },
        }
    },
    methods: {
        onSubmit() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            this.isDisabled = true;
            API.addHomeVideo(this.form,
                data => {
                    this.isDisabled = false;
                    this.$showNotification(data.data, 'success')
                    this.submitForm();
                },
                err => {
                    this.isDisabled = false;
                    this.errorMsg(err);
                }
            )
        },
        submitForm() {
            this.$refs.anyName.reset();
            this.$router.push({name: 'homepage_videos'});
        },
        errorMsg(err) {
            console.log(err);
            this.$showNotification({ message: "Failed system error" }, 'error')
        }
    }, computed: {},
}
</script>
